import { toast } from "react-toastify";
import Api from "../../../api/axios";
import { Button, Form, Input, Label, Select, StyledImgUpload } from "../../../styles";
import { upload } from "../../../assets";
import { convertFile } from "../../../utils/helpers";
import { useState } from "react";
import { useUserContext } from "../../../context/user_context";

const Kyc = () => {
      const [issending, setissending] = useState(false);

      const [formField, setformField] = useState({
            bvn: ''
      });
      const [id_photo, setId_photo] = useState(null);

      const { businessData, usertoken, userData, getUserData } = useUserContext();

      const {
            btoken,
      } = businessData;

      // Form Fields
      function handleChange(e) {
            setformField((inputs) => ({
                  ...inputs,
                  [e.target.name]: e.target.value,
            }));
      }
      // Form Field
      console.log(userData);

      function submitFn(e) {
            e.preventDefault();
            if ((
                  formField.bvn
            )) {
                  setissending(true);
                  const data = {
                        // id: formField.id,
                        // id_number: formField.id_number,
                        // id_photo: formField.id_photo,
                        bvn: formField.bvn,
                        btoken, usertoken
                  };
                  Api.post(`/user/bvn.update`, data)
                        .then((res) => {
                              if (res.success === false) {
                                    toast.warn(res.message);
                                    setissending(false);
                              } else {
                                    setissending(false);
                                    toast.success(res.message);
                                    getUserData();
                              }
                        })
                        .catch((error) => {
                              setissending(false);
                        });
            } else {
                  setissending(false);
                  toast.warn("Empty Fields !!!");
            }
      }

      return (

            <Form onSubmit={(e) => submitFn(e)}>

                  <div className="mx-auto mt-5 col-md-8">
                        {/* <div className="justify-content-between row">
                              <div className="col-md-4">
                                    <Label> ID: </Label>
                              </div>
                              <div className="col-md-8">
                                    <Select
                                          name="id"
                                          onChange={handleChange}
                                          required
                                          value={formField.id}
                                    >
                                          <option value="">Select ID</option>
                                          <option value="nin">NIN</option>
                                          <option value="voters card">Voter's Card</option>
                                          <option value="passport">International Passport</option>

                                    </Select>
                              </div>
                        </div> */}
                        <div className="justify-content-between row">
                              <div className="col-md-4">
                                    <Label> BVN: </Label>
                              </div>
                              <div className="col-md-8">
                                    <Input
                                          type="text"
                                          name="bvn"
                                          placeholder="Enter BVN"
                                          onChange={handleChange}
                                          value={formField.bvn}
                                          required
                                    />
                              </div>
                        </div>
                        {/* <div className="justify-content-between row">
                              <div className="col-md-4">
                                    <Label> Upload ID: </Label>
                              </div>
                              <div className="col-md-8">

                                    <Input
                                          type="file"
                                          accept="image/*"
                                          onChange={(e) => convertFile(e, setId_photo, id_photo)}
                                    />

                                                              </div>
                        </div> */}

                        <div className="mx-auto mb-4 text-center col-md-12">
                              <Button
                                    pry
                                    type="submit"
                                    disabled={issending}
                                    className="m-0 w-100 btn"  >
                                    {issending ? 'loading...' : "Submit"}
                              </Button>
                        </div>
                  </div>
            </Form>
      );
};

export default Kyc;